import { Api } from '../../core/api';

const topMenuApi = new Api({
  useEagleApi: true,
  initialData: { items: [] },
  namespace: 'TOP_MENU_ITEMS',
  url: '/internal-intranet/menu',
});
export const fetchTopMenu = (parentMenuItemId: string) => {
  return topMenuApi.fetch({
    urlParams: `?parentId=${parentMenuItemId}&admin=false`,
  });
};

export const topMenuApiReducer = topMenuApi.reducer;

const sideMenuApi = new Api({
  useEagleApi: true,
  initialData: { items: [] },
  namespace: 'SIDE_MENU_ITEMS',
  url: '/internal-intranet/menu',
});
export const fetchSideMenu = (parentMenuItemId: string) => {
  return sideMenuApi.fetch({
    urlParams: `?parentId=${parentMenuItemId}&admin=false`,
  });
};

export const sideMenuApiReducer = sideMenuApi.reducer;

const nestedSideMenuApi = new Api({
  useEagleApi: true,
  namespace: 'NESTED_SIDE_MENU_ITEMS',
  url: '/internal-intranet/menu',
});
export const fetchNestedSideMenu = (parentMenuItemId: string) => {
  return nestedSideMenuApi.fetch({
    urlParams: `?parentId=${parentMenuItemId}&admin=false`,
  });
};
